import Metadata from "./Metadata";
import { IAnswerItem } from "../../../types"
import MarkdownBodyParser from '../../../lib/MarkdownBodyParser'
import questionParser from '../../../helpers/question-parser'
import AnswerItem from '../../../common/AnswerItem'

export default class Question {
  public id:number
  public index:number
  readonly _body:string
  readonly length:number
  public fieldType:string
  public test:boolean
  public answerItems: AnswerItem[] = []
  public group: number
  public metadata: Metadata

  constructor (metadata: Metadata, body:string = "", group:number = 0) {
    this.metadata = metadata;
    this.group = group;
    this._body = body;
    this.length = body.split("\n").length;

    this.parseBody(body);
  }

  public get body():string {
    return this._body.trim();
  }

  public get toParams() {
    const answer_items = this.answerItems.map((answer_item) => answer_item.toParams)
    let body = this._body
    const html_body = questionParser(body, this.fieldType, false)
    return {body, answer_items, type: this.fieldType, test: this.test, html_body, group: this.group, explanation: this.metadata.explanation, skill_item_ids: this.metadata.skillItemIds}
  }

  private parseBody(body: string) {
    const parser = new MarkdownBodyParser(body)
    if (!parser.fieldType) return
    this.fieldType = parser.fieldType
    this.test = parser.isTest
    this.answerItems = parser.answerItems
  }
}
